<script setup lang="ts">
import { useAuthStore } from "../stores/auth"
import { LogOut, LogIn, Rocket } from "lucide-vue-next"

const auth = useAuthStore()
</script>

<template>
  <header class="bg-navy text-white">
    <div class="px-6 h-14 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <Rocket class="w-5 h-5 text-orange-soft" />
        <span class="font-bold tracking-wide">CYNTEGRITY</span>
        <span class="text-orange-soft font-semibold">Mission Control</span>
      </div>
      <div class="flex items-center gap-4">
        <span v-if="auth.signedIn" class="text-sm text-white/80">{{ auth.displayName }}</span>
        <button v-if="auth.signedIn" @click="auth.signOut()" class="flex items-center gap-2 text-sm hover:text-orange-soft">
          <LogOut class="w-4 h-4" />Sign out
        </button>
        <button v-else @click="auth.signIn()" class="flex items-center gap-2 text-sm hover:text-orange-soft">
          <LogIn class="w-4 h-4" />Sign in
        </button>
      </div>
    </div>
  </header>
</template>
